<div class="body">

    <span class="fiv-sqo file-icon" [ngClass]="fileType$|async"></span>

    <div class="file-name">

        {{fileName$|async}}

    </div>

</div>